import { selectMailStoreItemById } from 'owa-mail-store';
import Message from 'owa-service/lib/contract/Message';

const getSenderFromItemId = function (itemId: string): string {
    const message = (itemId && selectMailStoreItemById(itemId)) as Message;
    return (message?.From || message?.Sender)?.Mailbox?.EmailAddress;
};

export default getSenderFromItemId;
